import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CORE_SERVICES } from "./services";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { LoaderInterceptor } from "./interceptors/loader.interceptor";
import { CORE_RESOLVERS } from "./resolvers";
import { DatePipe } from "@angular/common";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { ConfirmationService } from "primeng/api";
import { TranslateModule } from "@ngx-translate/core";
import { LoggerInterceptor } from "./interceptors/logger.interceptor";


@NgModule({
  imports: [BrowserAnimationsModule, TranslateModule],
  providers: [
    ...CORE_SERVICES,
    ...CORE_RESOLVERS,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggerInterceptor, multi: true },
    ConfirmationService,
    DatePipe,
  ],
  exports: [BrowserAnimationsModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
